import axios from 'axios'
import Auth from './Auth'
import Request from '../Http/Request'
import ServiceProvider from 'App/Support/ServiceProvider'

/**
 * The default API url/path to use when not specified in the environment.
 *
 * @type {String}
 */
const DEFAULT_API_URL = 'api'

/**
 * The API url environmnent key name.
 *
 * @type {String}
 */
const VUE_APP_AUTH_API_URL = 'VUE_APP_AUTH_API_URL'

/**
 * The API url path environmnent key name.
 *
 * @type {String}
 */
const VUE_APP_API_PATH = 'VUE_APP_API_PATH'

/**
 * Authentication service provider.
 *
 * @author Erik Galloway <egalloway@claruscare.com>
 */
export default class AuthServiceProvider extends ServiceProvider {
	/**
	 * Boot the application's registered services.
	 *
	 * @return {void}
	 */
	async boot() {
		const auth = this.app.use('App/Auth/Auth')

		if (process.env.NODE_ENV === 'test') {
			return (auth._booted = true)
		}

		await auth.boot()
	}

	/**
	 * Register bindings in the container.
	 *
	 * @return {void}
	 */
	register() {
		// Register the Auth manager instance
		this.app.singleton('App/Auth/Auth', container => {
			const app = container.use('App/Foundation/Application')

			return new Auth(app)
		})

		// Register auth-specific axios instance for Auth API service
		this.app.singleton('axios.auth', () => {
			return axios.create({
				baseURL: this._getBaseUrl(),
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
				},
			})
		})

		// Register auth-specific Request instance for Auth API service
		this.app.singleton('App/Http/AuthRequest', ioc => {
			return new Request(ioc.use('axios.auth'))
		})
	}

	/**
	 * Get the environment's base API url or path.
	 *
	 * @return {String}
	 */
	_getBaseUrl() {
		const url = process.env[VUE_APP_AUTH_API_URL]
		const path = process.env[VUE_APP_API_PATH]

		if (!url) {
			return DEFAULT_API_URL
		}

		return `${url}/${path}`
	}
}
